<template>
  <div class="logistics-affirm">
    <div style="text-align: right">
      <el-button-export
        :url="downloadUrl"
        size="small"
        type="success"
      >下载</el-button-export>
    </div>
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="销售记录" name="first">
          <div class="table-form" style="height:20%">
            <p class="form-name">销 售 记 录</p>
            <div class="form-info">
              <p>经销商：{{ form.fDistributor }} <span style="float: right;">单据编号：{{ form.fBillNo }}</span></p>
            </div>
          </div>
          <el-table
            v-el-table-height-fix
            :data="pTableData"
            height="80%"
          >
            <el-table-column label="送货单号" prop="fOrderNo" min-width="130" />
            <el-table-column label="销售日期" prop="fSalesDate" min-width="100" :formatter="dataFormat2" label-class-name="font-color-red" />
            <el-table-column label="购货单位" prop="fCustomer" min-width="130" label-class-name="font-color-red" />
            <el-table-column label="地址" prop="fAddress" min-width="150" label-class-name="font-color-red" />
            <el-table-column label="联系人" prop="fName" min-width="80" label-class-name="font-color-red" />
            <el-table-column label="电话" prop="fPhone" min-width="140" label-class-name="font-color-red" />
            <el-table-column label="产品编号" prop="fNumber" min-width="110" />
            <el-table-column label="产品名称" prop="ficItem" min-width="140" />
            <el-table-column label="规格型号" prop="fModel" min-width="140" />
            <el-table-column label="单位" prop="fUnit" width="50" />
            <el-table-column label="数量" prop="fQty" min-width="100" label-class-name="font-color-red" />
            <el-table-column label="出仓单号" prop="fCkBillNo" min-width="100" />
            <el-table-column label="生产批号" prop="fBatchNo" min-width="110" />
            <el-table-column label="生产日期" prop="fDate_Sc" :formatter="dataFormat2" min-width="100" />
            <el-table-column label="消毒日期" prop="fDate_Xd" :formatter="dataFormat2" min-width="100" />
            <el-table-column label="追溯号" prop="fRetroactiveNo" min-width="170" label-class-name="font-color-red" />
            <el-table-column label="有效期(月)" prop="fValidity" min-width="100" />
            <el-table-column label="库存" prop="inventoryQty" min-width="80" />
            <el-table-column label="备注" prop="fDes" min-width="150" />
          </el-table>
          <div class="fSeal-img">
            <img :src="form.fSealUrl" alt="" style="margin-left: 50%;height: 110px;position:absolute;top:30%;z-index:1;opacity: 0.4;">
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="!isNew" label="单据流程" name="third">
          <el-table :data="form.procedureMessage" height="100%">
            <el-table-column label="流程步骤" prop="fName" />
            <el-table-column label="处理人" prop="fUserName" />
            <el-table-column label="状态" prop="fState" />
            <el-table-column
              label="日期"
              prop="fDate"
              :formatter="dateFormat"
            />
            <el-table-column label="意见" prop="fOpinion" />
          </el-table>
        </el-tab-pane>
        <el-form
          ref="form"
          v-loading="loading"
          :model="form"
          :rules="rules"
          label-width="78px"
          style="overflow: auto"
        >
          <el-form-item
            label="审批意见"
            style="margin-top: 10px"
            class="formitem"
          >
            <el-input
              v-model="form.procedureInfo.fOpinion"
              type="textarea"
              rows="4"
              style="width: 100%"
            />
          </el-form-item>
        </el-form>
        <el-button
          v-if="canAudit"
          type="primary"
          :disabled="saving"
          style="margin-left: 78px"
          @click="submit(1)"
        >通过</el-button>
        <el-button
          v-if="canAudit"
          type="warning"
          :disabled="saving"
          style=""
          @click="submit(2)"
        >回退</el-button>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'
import ReturnNode from '@components/ReturnNode'

export default {
  inject: ['getMap'],
  components: {

  },
  data: function() {
    return {
      form: {
        procedureInfo: {},
        orderInfo: {},
        logoInfo: {},
        procedureMessage: [],
        stockInfo: {}
      },
      pTableData: [],
      rules: {},

      activeName: 'first',
      printing: false,

      saving: false,
      loading: false,
      isNew: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {
    canAudit: function() {
      if (this.form) {
        if (this.form.readOnly == false) {
          return true
        }
      }
      return false
    }
  },
  mounted() {},
  methods: {
    submit: function(type) {
      this.$refs.form.validate(async(valid) => {
        this.form.procedureInfo.fType = type
        if (valid) {
          if (type == 2) {
            if (!this.form.procedureInfo.fOpinion) {
              this.activeName = 'second'
              this.$message.error('请填写审核意见')
              return
            }
          }

          const flg = await this.confirm('是否提交?')
          if (!flg) return

          this.saving = true
          this.$httpPost('SalesRecordManage/SalesRecordSp1/SalesRecordApproval', {
            datalist: JSON.stringify(this.form)
          })
            .then((res) => {
              if (!res.isSuccess) {
                this.$message.error(res.message)
                return
              }

              // 重新刷新页面数据
              this.$message.success(res.message)
              if (this.$route.query.ishome) {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/' })
              } else {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({
                  path: '/distributorManagement/ReviewOfSalesRecords'
                })
              }
            })
            .finally(() => (this.saving = false))
        } else {
          this.activeName = 'first'
          return false
        }
      })
    },
    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      this.isNew = !id
      if (id == 0) {
        this.form = {
          procedureInfo: {},
          entrys: []
        }
        return
      }

      this.loading = true
      const res = await this.$httpPost(
        'SalesRecordManage/SalesRecordSp1/GetSalesRecord',
        {
          fid: id
        }
      ).finally(() => (this.loading = false))
      console.log(res, 'ress')
      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
      this.pTableData = this.form.entrys
    },
    confirm: function(msg) {
      return this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => true)
        .catch(() => false)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const rowlength1 = this.pTableData.length - 1
      const rowlength2 = this.pTableData.length - 2
      if (rowIndex === rowlength2) {
        if (columnIndex === 1) {
          return [1, 9]
        }
      }
      if (rowIndex === rowlength1) {
        if (columnIndex === 1) {
          return [1, 9]
        }
      }
    },
    print: async function() {
      this.printing = true
      let printversion
      let success
      const fControlledNumber = this.form.stockInfo.fControlledNumber
      console.log(this.form, 'form')
      // 旧的打印模块
      if (
        fControlledNumber == 'SS-FOR-08-04B' ||
        fControlledNumber == 'WYJK-QPR-04-01A'
      ) {
        printversion = 'printVoucher2'
        success = await this.$refs.printVoucher2.refresh(this.form.fid)
      } else {
        // 新的打印模块
        printversion = 'printVoucher1'
        success = await this.$refs.printVoucher1.refresh(this.form.fid)
      }
      if (!success) {
        this.printing = false
        return
      }
      // https://www.npmjs.com/package/vue-print-nb
      new printnb({
        ids: printversion, // * 局部打印必传入id
        standard: '', // 文档类型，默认是html5，可选 html5，loose，strict
        extraHead: '', // 附加在head标签上的额外标签,使用逗号分隔
        extraCss: '', // 额外的css连接，多个逗号分开
        popTitle: '', // title的标题
        endCallback() {
          // 调用打印之后的回调事件
        }
      })
      setTimeout(() => {
        this.printing = false
      }, 100)
    },
    //    日期格式转换
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD ')
    },
    dataFormat2: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD ')
    },
    downloadUrl: function() {
      return this.$buildDownloadUrl('Download/SalesRecordInfoDownload', {
        fid: this.form.fid
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
<style lang="less">
.logistics-affirm {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #000;
    cursor: not-allowed;
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 200px);
      .el-tab-pane {
        height: calc(100vh - 200px);
      }
    }
  }
  .formitem {
    .el-form-item__label {
      margin: 26px 0;
      // width: 78px !important;
    }
    .el-form-item__content {
      // margin-left: 89px !important;
    }
  }

  .table-form {
    width: 99%;
    table {
      font-size: 12px;
    }
    .el-table {
      color: #000;
    }
    .el-table td,
    .el-table th {
      // padding: 0px 0;
    }
    .el-table__header tr,
    .el-table__header th {
      padding: 0;
    }
    .el-table td,
    .el-table th.is-leaf,
    .el-table--border,
    .el-table--group {
      border-color: black;
    }
    .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      background-color: black;
    }
    .el-table thead {
      color: #000;
      font-weight: 500;
    }
    .form-name {
      font-weight: bold;
      font-size: 25px;
      font-family: 华文行楷;
      margin: 0 auto;
      text-align: center;
    }
    .form-logo {
      display: flex;
      div {
        flex-direction: column;
      }

      p {
        margin: 0px;
      }
      .fCompany {
        height: 40px;
        line-height: 40px;
        font-size: 13px;
      }
      .fCompanyEnglish {
        font-size: 7px;
        height: 8px;
      }
    }
    .form-info {
      font-size: 14px;
      span {
        margin-left: 35px;
      }
    }
    .form-foot {
      display: flex;
      font-size: 14px;
      margin-top: 5px;
      span {
        flex: 1;
        //  flex-direction:column;
        justify-content: space-between;
      }
    }
    .a-Table {
      border-collapse: collapse;
      width: 100%;
      // text-align: center;
      // border: 1px solid #000;
      tr {
        display: flex;
        border-right: 1px solid #000;
        text-indent: 10px;
        td {
          flex: 1;
          border-bottom: none;
          border-right: none;
        }
        th {
          flex: 1;
          text-align: left;
          border-bottom: none;
          border-right: none;
        }
      }
      table,
      td,
      th {
        border: 1px solid #000;
      }
    }
    .fSeal-img{
      display: flex;
      flex-direction:row;
      span{
     font-size:14px ;
      }
    img{
       height: 110px;
       }    }
  }
}
</style>
